import { useCallback } from "react";
import { convertToTimeZone } from "date-fns-timezone";
import { startOfDay, endOfDay } from "date-fns";

const US_CENTRAL_TIMEZONE = "America/Chicago";

export const useUSCentralTime = () => {
    const toCentralTime = useCallback((date) => convertToTimeZone(date, { timeZone: US_CENTRAL_TIMEZONE }), []);

    const getNow = useCallback(() => toCentralTime(new Date()), [toCentralTime]);

    const now = getNow();
    const todayStart = startOfDay(now);
    const todayEnd = endOfDay(now);

    return { getNow, todayStart, todayEnd, toCentralTime };
};
